export const sentrySensitiveProps = ['email', 'firstName', 'lastName', 'password', 'token'];
